/* eslint-disable no-undef */
import './gt4.js'
import axios from 'axios'
import _tools from "@/framework/common/qds_tools";
let loginInfo = _tools.getCookie('QDS_LOGIN_INFO_OFFICE');
const info = loginInfo && JSON.parse(decodeURIComponent(loginInfo))
export const captchaId = '29f2b35bc3dd5e52d3c5437c4482ab95'
export function validateGeeTest4 (params) {
  return getData(params, '/shield/validateGeeTest4')
}
export async function getData (data, url) {
  let params = {
    userId: info.userId,
    identityIde: info.userId,
    appKey: "quandashi9838616927",
    timestamp: new Date().getTime(),
    format: "json",
    h5Query: 0,
    signMethod: "md5",
    executor: info.userId,
    sign: new Date().getTime() + '' + Math.floor((Math.random() * 10000) + 1),
    v: "1.0",
  }
  const res = await axios.post(url, {...params, ...data})
  if (res.code === 9091) {
    if (res.subCode === 10002) {
      return res.data
    } else {
      return false
    }
  } else if (res.code == 8888) {
    return Promise.reject(res)
  } else {
    console.error(res.data.message)
  }
}
const validateGee = async (data, fn, type) => {
  const params = {
    module: 'brand',
    methods: type,
    CheckGt4Type: 'PCWenShu_4',
    captchaOutput: data.captcha_output,
    genTime: data.gen_time,
    lotNumber: data.lot_number,
    passToken: data.pass_token,
  }
  const res = await validateGeeTest4(params)
  console.log(res)
  // if (res) {
  fn()
  // }
}

export const geetest4 = async (callback, type) => {
  initGeetest4({captchaId, product: 'bind', language: 'zho', riskType: 'word', hideClose: true, mask: { outside: false, bgColor: '#999' }}, (captchaObj) => {
    captchaObj.onReady(() => {
      captchaObj.showCaptcha()
    }).onSuccess(() => {
      var result = captchaObj.getValidate()
      validateGee(result, callback, type)
    }).onError(() => {
      captchaObj.reset()
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/geetest.js